'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.YouTube = void 0;
var $ = require("jquery");
var YouTubeIframeLoader = require("youtube-iframe");
var YouTube = /** @class */ (function () {
    function YouTube() {
        var _this = this;
        this.lastBrowserWidth = 0;
        var self = this;
        // 画面OFF対策
        document.addEventListener("visibilitychange", function () {
            if ($('#bulletTopYouTube').length) {
                if (document.visibilityState === 'visible') {
                    _this.reloadIframe();
                }
            }
        });
        // イベント
        this.resizeYouTubePlayer();
        setPlayer();
        $(window).on('resize', function () {
            if (!_this.isMobileSize()) {
                _this.resizeYouTubePlayer();
            }
            else {
                if (self.lastBrowserWidth !== $(window).outerWidth()) {
                    _this.resizeYouTubePlayer();
                    self.lastBrowserWidth = $(window).outerWidth();
                }
            }
        });
        // YouTube Playerのセット
        function setPlayer() {
            var youTubeId = '7rJJeGjwTWg';
            self.lastBrowserWidth = $(window).outerWidth();
            YouTubeIframeLoader.load(function (YT) {
                var player = new YT.Player('bulletTopPlayer', // 埋め込む場所の指定
                {
                    videoId: youTubeId,
                    playerVars: {
                        rel: 0,
                        loop: 1,
                        playlist: youTubeId,
                        controls: 0,
                        autoplay: 1,
                        showinfo: 0, //動画タイトルなど表示しない
                    },
                    events: {
                        'onReady': onPlayerReady
                    }
                });
            });
        }
        //プレイ準備完了後
        function onPlayerReady(event) {
            event.target.mute();
            event.target.playVideo();
            event.target.setPlaybackQuality("hd1080");
            $('.bulletMainVisual').css('background-image', 'none');
        }
    }
    // YouTubeの表示領域を変更
    YouTube.prototype.resizeYouTubePlayer = function () {
        var headerHeight = $('.paramHeader').outerHeight();
        var browserHeight = $(window).height();
        var footerMargin = 40;
        if (this.isMobileSize()) {
            footerMargin = 20;
        }
        var viewHeight = browserHeight - headerHeight - footerMargin;
        $('#bulletTopYouTube').css({ height: viewHeight });
        this.resizePlayer();
    };
    // YouTubeを中心に表示するように
    YouTube.prototype.resizePlayer = function () {
        var getYouTubePlayerWidth = $('#bulletTopYouTube').outerWidth();
        var getYouTubePlayerHeight = $('#bulletTopYouTube').outerHeight();
        var screenSwitch = 0.5625;
        var screenRatio = getYouTubePlayerHeight / getYouTubePlayerWidth;
        var ratioHeight = getYouTubePlayerHeight / screenSwitch;
        var ratioWidth = getYouTubePlayerWidth / screenSwitch;
        if (screenRatio > screenSwitch) {
            $('#bulletTopPlayer').css({
                height: "100%",
                width: ratioHeight,
                "margin-top": "0",
                "margin-left": -ratioHeight / 2,
                left: "50%",
                top: "0"
            });
        }
        else {
            $('#bulletTopPlayer').css({
                width: "100%",
                height: ratioWidth,
                "margin-top": -ratioWidth / 2,
                "margin-left": "0",
                top: "50%",
                left: "0"
            });
        }
    };
    // iframeの再読み込み
    YouTube.prototype.reloadIframe = function () {
        var src = $('#bulletTopPlayer').attr('src');
        $('iframe').attr('src', '');
        $('iframe').attr('src', src);
    };
    // スマートフォン・タブレットサイズの判定
    YouTube.prototype.isMobileSize = function () {
        var smartPhoneAndTabletSize = 1024;
        var browserWidth = $(window).outerWidth();
        return (smartPhoneAndTabletSize > browserWidth) ? true : false;
    };
    return YouTube;
}());
exports.YouTube = YouTube;
exports.default = YouTube;
